/**
 * Thai the Knot postcard templates.
 * Uses same URL structure as legacy template view; replace with your own template URLs and API as needed.
 */

const TEMPLATE_BASE = 'https://stack2.travpromobile.com/templates';

export const postcardTemplates = [
  {
    id: 'thai-template-1',
    title: 'Template 1',
    filename: '1.jpg',
    url: `${TEMPLATE_BASE}/1.jpg`,
    thumbnail: `${TEMPLATE_BASE}/1.jpg`,
    template_id: '1'
  },
  {
    id: 'thai-template-2',
    title: 'Template 2',
    filename: '2.jpg',
    url: `${TEMPLATE_BASE}/2.jpg`,
    thumbnail: `${TEMPLATE_BASE}/2.jpg`,
    template_id: '3'
  },
  {
    id: 'thai-template-3',
    title: 'Template 3',
    filename: '3.jpg',
    url: `${TEMPLATE_BASE}/3.jpg`,
    thumbnail: `${TEMPLATE_BASE}/3.jpg`,
    template_id: '4'
  }
];

export default postcardTemplates;
